import React from 'react';
import { Admin, Resource, fetchUtils } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';

import { createMuiTheme } from '@material-ui/core/styles';

import UserIcon from '@material-ui/icons/Group';
import SiteIcon from '@material-ui/icons/LocationCity';
import RoleIcon from '@material-ui/icons/Work';

import authProvider from './resources/authProvider';
import AppLogin from './pages/AppLogin';

import Dashboard from './resources/dashboard';
import { UserList, UserEdit, UserCreate, UserShow } from './resources/users';
import { SiteList, SiteEdit, SiteCreate, SiteShow } from './resources/sites';
import { ClientList, ClientEdit, ClientCreate, ClientShow } from './resources/clients';
import { SupplierList, SupplierEdit, SupplierCreate, SupplierShow } from './resources/suppliers';
import { RoleList, RoleEdit, RoleCreate, RoleShow } from './resources/roles';
//import { EntityShow } from './resources/entities';

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
};
const dataProvider = jsonServerProvider('/Data', httpClient);

const theme = createMuiTheme({
    /*palette: {
        primary: indigo,
        secondary: pink,
        error: red,
        contrastThreshold: 3,
        tonalOffset: 0.2,
    },*/
    palette: {
		/*type: 'dark',*//*
		primary: 'indigo',
		secondary: 'pink',
		error: 'red'*/
		secondary: {
			main: '#cc020b'
		}
    },
    typography: {
        fontFamily: [
			'Roboto',
            'sans-serif'
        ].join(','),
        fontSize: '20px'
    }/*
    overrides: {
        MuiButton: { // override the styles of all instances of this component
            root: { // Name of the rule
                color: 'white', // Some CSS
            },
        },
    },*/
});

const App = () => (
	<Admin title="MSS Admin" dashboard={Dashboard} loginPage={AppLogin} authProvider={authProvider} theme={theme} dataProvider={dataProvider}>
        <Resource name="User" list={UserList} edit={UserEdit} create={UserCreate} show={UserShow} icon={UserIcon} />
        <Resource name="Site" list={SiteList} edit={SiteEdit} create={SiteCreate} show={SiteShow} icon={SiteIcon} />
        <Resource name="Client" list={ClientList} edit={ClientEdit} create={ClientCreate} show={ClientShow} />
		<Resource name="Supplier" list={SupplierList} edit={SupplierEdit} create={SupplierCreate} show={SupplierShow} />
        <Resource name="Role" list={RoleList} edit={RoleEdit} create={RoleCreate} show={RoleShow} icon={RoleIcon} />
    </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js